//import { formatJsonLocation as fjl, formatLocation } from "../../components/renderers";
//import { formatJsonDataset as fjd } from "../../components/renderers";
import {authbasic} from './authbasic';
import {corebasic} from './corebasic';
import {uiuxbasic} from './uiuxbasic';
import {mainbasic} from './mainbasic';
import {reportbasic} from './reportbasic';
import {uploadbasic} from './uploadbasic';
import {apisbasic } from './apisbasic';
import {filebasic } from './filesbasic';
import {financebasic } from './financebasic';
import {eventsbasic } from './eventsbasic';
import {flowsbasic } from './flowsbasic';
import { formsbasic } from './formsbasic';
import { activitybasic } from './activitybasic';

export const basicconfig = {
  ...authbasic,
  ...corebasic,
  ...uiuxbasic,
  ...mainbasic,
  ...reportbasic,
  ...uploadbasic,
  ...apisbasic,
  ...filebasic,
  ...financebasic,
  ...eventsbasic,
  ...flowsbasic,
  ...formsbasic,
  ...activitybasic
};
